import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService, CookieData } from 'src/app/services/auth/auth.service';
import { TrpcService } from 'src/app/services/trpc/trpc.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  formSubmitted: boolean = false;
  loginFormGroup!: FormGroup;
  loginInProgress: boolean = false;

  constructor(
    private trpcService: TrpcService,
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router) { }

  ngOnInit() {
    this.authService.isAuthenticatedObservable.next(false);

    this.loginFormGroup = new FormGroup({
      username: new FormControl<string | null>(null, [Validators.required]),
      password: new FormControl<string | null>(null, [Validators.required]),
    });
  }

  async login(): Promise<void> {

    this.formSubmitted = true;

    this.loginFormGroup.markAllAsTouched();
    if (this.loginFormGroup.invalid) {
      return;
    }

    try {

      this.loginInProgress = true;

      const { username, password } = this.loginFormGroup.value;

      const result: any = await this.trpcService.trpc.authRouter.loginNG.mutate({
        username,
        password
      });

      console.log('Login successful:', result);

      // Display detailed user information
      const userInfo = result.user;

      // Set the cookie data in AuthService and TrpcService if session info is available
      if (userInfo.sessionName && userInfo.sessionId) {
        const cookieData: CookieData = {
          cookie: {
            name: userInfo.sessionName,
            value: userInfo.sessionId
          }
        };

        // Store the cookie data in AuthService and localStorage
        this.authService.saveCookieToStorage(cookieData);

        // Update TrpcService with the new token
        this.trpcService.setToken(cookieData);
        
        this.authService.saveCookieToStorage(cookieData);
        
        this.authService.isAuthenticatedObservable.next(true);

        this.router.navigate(['/dashboard']);
      }

    } catch (error: any) {
      this.messageService.add({
        severity: 'error',
        detail: error.message,
      });
    } finally {
      this.loginInProgress = false;
    }
  }
}
